import { Button, DepcrecatedSelect, FIELD_HEIGHT, Icon, MuiMenuItem, Popover, Typography, strIsNullOrEmpty } from '@fox/atoms';
import React from 'react';
import { ThemeContext } from 'styled-components';
import { useAutoDataGridContext } from '../../auto-data-grid/context';
import { GraphColumn } from '../../auto-data-grid/types';

export function GroupByPopover<T>(props: { columns: GraphColumn<T>[] }) {
	const { columns } = props;
	const { groupBy, setGroupBy } = useAutoDataGridContext();
	const theme = React.useContext(ThemeContext);
	const [vis, setVis] = React.useState(false);

	const overlay = (
		<div>
			<div style={{ padding: '1rem' }}>
				<Typography variant="h6">Group by</Typography>
				<DepcrecatedSelect
					style={{ width: 500, height: FIELD_HEIGHT, marginTop: '1rem' }}
					value={groupBy}
					multiple={false}
					onChange={e => {
						setGroupBy(e.target.value);
						setVis(false);
					}}
				>
					{columns.map(o => {
						return (
							<MuiMenuItem value={o.dataIndex} key={o.dataIndex}>
								{o.title}
							</MuiMenuItem>
						);
					})}
				</DepcrecatedSelect>
			</div>
			<hr style={{ width: '100%', border: '1px solid rgba(0, 0, 0, 0.12)', margin: 0 }} />
			<div style={{ padding: '1rem' }}>
				<Button
					color="error"
					disabled={strIsNullOrEmpty(groupBy)}
					onClick={() => {
						setGroupBy(undefined);
					}}
				>
					Clear
				</Button>
			</div>
		</div>
	);

	return (
		<Popover overlay={overlay} placement="bottom-start" trigger="click" onVisibleChange={setVis} visible={vis}>
			<Button
				startIcon={<Icon iconName={'TableView'} />}
				//variant={'text'}
				style={{ color: theme.colors.font, backgroundColor: strIsNullOrEmpty(groupBy) ? '' : theme.colors.grey[200] }}
				sx={{
					'&:hover': { opacity: strIsNullOrEmpty(groupBy) ? 'unset' : '0.8 !important' }
				}}
			>
				Group By
			</Button>
		</Popover>
	);
}
